import { hasData } from "./hasData"

export function followerFormat(n,singular,plural) {
    var descriptor = ''
    if (hasData(singular)) {}
        descriptor = n == 1 ? ` ${singular}` : ` ${plural}`
    return `${n}${descriptor}`
}